import gql from 'graphql-tag';

const albumFolderCustomTags = gql`
  fragment albumFolderCustomTags on AlbumFolder {
    tags(slice: { limit: 999 }, album_folder_tag_types: CUSTOM) {
      total
      records {
        ... on IRecord {
          id
        }
        ... on IAlbumFolderTag {
          name
          type
          is_pricing_tag
          digital_downloads_enabled
          digital_downloads_price {
            value
            currency
          }
        }
      }
    }
  }
`;

export default albumFolderCustomTags;
